import { STOP_TYPE as ALT_STOP_TYPE } from 'types'
import { IShipmentStopAppointmentTypes } from 'types/graphqlTypes'

export enum STOP_TYPE {
  pickup = 'pickup',
  dropoff = 'dropoff',
}

export type TAltStopType = keyof typeof ALT_STOP_TYPE

export type TStopType = STOP_TYPE | ALT_STOP_TYPE | TAltStopType | IShipmentStopAppointmentTypes

export type TMapMarkerStyle = 'traditional' | 'newWave' | 'disabled'
